/* -----------------------------------------------------------------
  CONFIG ELEMENT HELPER
----------------------------------------------------------------- */
function _e(selector) {
  return new config.element._instance(selector);
}

/* -----------------------------------------------------------------
  CONFIG OBJECT
----------------------------------------------------------------- */
var config = {
  siteUrl: config.siteUrl,
  mobileBreak: 808
};

/* -----------------------------------------------------------------
  CONFIG WOW OBJECT
  Remove when migrating config object to site not using WOW for
  animations.
----------------------------------------------------------------- */
if (typeof WOW == 'function') {
  config.wowInit = function() {
    config.wow = new WOW();
    config.wow.destroy = function() {
      $('.wow').removeClass('wow');
    }
  }();
}

/* -----------------------------------------------------------------
  CONFIG REQUEST OBJECT
----------------------------------------------------------------- */
config.request = {
  _cache: [],

  _request: function(type, url, dataOrCallback, callback, dataType) {

    if (dataOrCallback instanceof Object || typeof dataOrCallback == 'string') {
      var data = dataOrCallback;
    } else {
      var data = false;
      console.log(dataOrCallback);
      callback = dataOrCallback;
    }

    var cacheIndex = data ? type + ':' + url + '?' + $.param(data) : type + ':' + url;
    var cache = this._cache[cacheIndex];

    if (cache) {
      callback(cache, {fromCache: true, cacheIndex: cacheIndex});
    } else {
      $.ajax({
        type: type,
        url: url,
        data: data,
        success: function(data) {
          config.request._cache[cacheIndex] = data;
          callback(data, {fromCache: false, cacheIndex: cacheIndex});
        },
        dataType: dataType,
        cache: false
      });
    }
  },

  post: function(url, dataOrCallback, callback, dataType) {
    this._request("POST", url, dataOrCallback, function(data, cached){
      callback(data, cached);
    }, dataType);
  },

  get: function(url, dataOrCallback, callback, dataType) {
    this._request("GET", url, dataOrCallback, function(data, cached){
      callback(data, cached);
    }, dataType);
  },

  load: function(element, url, dataOrCallback, callback, dataType, type) {
    type = type || "GET";
    _e(element).ready(function($element){
      config.request._request(type, url, dataOrCallback, function(data, cached){
        $element.html(data);
        callback(data, cached);
      }, dataType);
    }, 300);
  },
};

/* -----------------------------------------------------------------
  CONFIG ELEMENT
----------------------------------------------------------------- */
config.element = {
  _instances:  {},

  _instance: function(selector) {
    var self = this;
    this.sliding = false;

    if (selector instanceof jQuery) {
      this.selector = selector;
    } else {
      this.selector = $(selector);
    }

    this.ready = function(callback, timeout) {
      $(function(){
        var interval;
        var loop = 0;
        interval = setInterval(function(){
          ++loop;
          if (self.selector.length || (timeout && loop == timeout)) {
            if (self.selector.length) {
              callback(self.selector);
            }
            clearInterval(interval);
          }
        }, 50);
      });
    }

    this.load = function(url, dataOrCallback, callback, dataType, type) {
      config.request.load(self.selector, url, dataOrCallback, function(data, cached){
        callback(data, cached);
      }, dataType, type);
    }

    this.toggleText = function(object){
      self.ready(function($element){
        $element.text(object.onCondition ? object[1] : object[0]);
      });
    }

    this.centerScreenOn = function(scrollSpeed){
      scrollSpeed = scrollSpeed || 200;
      self.ready(function($element){
        $('html, body').animate({
          scrollTop: $element.offset().top - $(window).height()/2 + $element.outerHeight()/2
        }, scrollSpeed);
      });
    }

    this.slideFadeDown = function(speed, callback) {
      speed = speed || 200;
      self.ready(function($element){
        if (!$element.is(':visible')) {
          $element
            .css('opacity', 0)
            .slideDown(speed)
            .animate({ opacity: 1 }, {
              queue: false,
              duration: speed,
              complete: callback
            });
        }
      });
    }

    this.slideFadeUp = function(speed, callback) {
      speed = speed || 200;
      self.ready(function($element){
        if ($element.is(':visible')) {
          $element
            .css('opacity', 1)
            .slideUp(speed)
            .animate({ opacity: 0 }, {
              queue: false,
              duration: speed,
              complete: callback
            });
          }
      });
    }

    this.slideFadeToggle = function(speed, callback) {
      self.ready(function($element){
        if (!self.sliding) {
          self.sliding = true;
          if ($element.is(':visible')) {
            self.slideFadeUp(speed, function(){
              self.sliding = false;
              if (callback) {
                callback();
              }
            });
          } else {
            self.slideFadeDown(speed, function(){
              self.sliding = false;
              if (callback) {
                callback();
              }
            });
          }
        }
      });
    }
  }
}

/* -----------------------------------------------------------------
  CONFIG LOCATION OBJECT
----------------------------------------------------------------- */
config.location = {
  current: window.location.pathname.substr(1) ? window.location.pathname.substr(1).replace(/\/$/, '') : 'index',
  root: window.location.pathname.split('/')[1],
  queryString: window.location.search,

  isRoot: function(root) {
    return root.replace(/(\/$|^\/)/g, '') === this.root;
  },

  isPage: function(current) {
    return current.replace(/(\/$|^\/)/g, '') === this.current;
  },

  getQueryString: function(string) {
    if (!window.location.search) {
      return false;
    }

    if (string) {
      var query = this.queryString;
    } else {
      var query = [];
      this.queryString.replace(/(^\?)/, '').split('&').forEach(function(param){
        param = param.split('=');
        query[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
      });
    }
    return query;
  },

  getParam: function(param) {
    var queries = this.getQueryString();
    param = param.trim();
    return (param && queries && queries[param]) ? queries[param] : false;
  }
};

/* -----------------------------------------------------------------
  CONFIG SCREEN OBJECT
----------------------------------------------------------------- */
config.screen = {
  _resizeCallbacks: [],
  _resize: function() {
    $(window).on('load resize', function(){
      var windowWidth = $(window).width();
      config.screen.size = windowWidth;
      if (config.screen._resizeCallbacks.length) {
        config.screen._resizeCallbacks.forEach(function(callback){
          callback(windowWidth);
        });
      }
    });
  }(),

  /*
    @var size | Int
    Current width of window. Adjusts as browser resizes.
  */
  size: $(window).width(),

  /*
    @method onResize
    @param callback | Function(windowWidth)

    Define a function to perform on window resize.
  */
  onResize: function(callback) {
    config.screen._resizeCallbacks.push(callback);
  },

  /*
    @method atSize
    @param size | Int
    @param callback | Function

    Define a function to perform when the window size is exactly
    the size passed to the first position.
  */
  atSize: function(size, callback) {
    config.screen.onResize(function(windowWidth){
      if (windowWidth === size) {
        callback(windowWidth);
      }
    });
  },

  /*
    @method whenSmallerThan
    @param size | Int
    @param callback | Function

    Define a function to perform ONCE when the window size becomes
    smaller than the size passed to the first position.
  */
  whenSmallerThan: function(size, callback) {
    var callbackFired = false;
    config.screen.onResize(function(windowWidth){
      if (windowWidth < size) {
        if (!callbackFired) {
          callback(windowWidth);
          callbackFired = true;
        }
      } else {
        callbackFired = false;
      }
    });
    return this;
  },

  /*
    @method whileSmallerThan
    @param size | Int
    @param callback | Function

    Define a function to perform while the window size is
    smaller than the size passed to the first position.
  */
  whileSmallerThan: function(size, callback) {
    config.screen.onResize(function(windowWidth){
      if (windowWidth < size) {
        callback(windowWidth);
      }
    });
    return this;
  },

  /*
    @method whenLargerThan
    @param size | Int
    @param callback | Function

    Define a function to perform ONCE when the window size becomes
    larger than the size passed to the first position.
  */
  whenLargerThan: function(size, callback) {
    var callbackFired = false;
    config.screen.onResize(function(windowWidth){
      if (windowWidth > size) {
        if (!callbackFired) {
          callback(windowWidth);
          callbackFired = true;
        }
      } else {
        callbackFired = false;
      }
    });
    return this;
  },

  /*
    @method whileLargerThan
    @param size | Int
    @param callback | Function

    Define a function to perform while the window size is
    larger than the size passed to the first position.
  */
  whileLargerThan: function(size, callback) {
    config.screen.onResize(function(windowWidth){
      if (windowWidth > size) {
        callback(windowWidth);
      }
    });
    return this;
  }
};

/* -----------------------------------------------------------------
  CONFIG EMAIL OBJECT
----------------------------------------------------------------- */
config.email = {
  elements: $('[data-mail-name]'),

  _convert: function($element) {
    $element.attr('href', 'mailto:' + $element.data('mail-name') + '@' + $element.data('mail-host'));
    if ($element.text() === '') {
      $element.text($element.data('mail-name') + '@' + $element.data('mail-host'));
    }
    $element.removeAttr('data-mail-name');
    $element.removeAttr('data-mail-host');
  },

  mailToInject: function(el) {
    if (el) {
      config.email._convert(el);
    } else {
      config.email.elements.each(function(){
        config.email._convert($(this));
      });
    }
  }
}

/* -----------------------------------------------------------------
  MAIL TO INJECT INIT
----------------------------------------------------------------- */
config.email.mailToInject();
